export const StationRoleGPIOoperationValues = [
    'None',
    'AttachToTime',
    'SetStartTimeNextGroup',
    'SetStartTimeParticipant',
    'SetStartTimeNextHeat',
    'AttachAndRoundToWholeMinute',
    'SetStartTimeParticipantWithBaasEqPort',
    'SetStartTimeNextArmedHeat',
    'SetStartNextParticipantOrNextArmedHeat',
] as const;
export type StationRoleGPIOoperation = (typeof StationRoleGPIOoperationValues)[number];
